
<div class="container-fluid">
    <app-page-header
        header="Define Release and Map Services"
        description="Define Release Configuration and Map Services">
        @if(ShowHealthStatus && this.userAuthService.checkPermission('MANAGE.RELEASE.DEPLOYMENT.HEALTH.STATUS')){
        <div header-right>
            <div class="header-right-section">
                <button class="mdc-button mdc-button--raised mdc-button--sharp ripple-material audit-trail-link"
                type="button"
                (click)="navigateToHealthStatus()"
                >
                <span class="mdc-button__ripple"></span>
                    Health check
                </button>
            </div>
        </div>
        }
    </app-page-header>
    <div class="release-main-container">
        
        <div class="release-toolbar-row">
            <p class="release-title">
                Release: {{ releaseTitle }}
            </p>
            <button mat-icon-button class="refresh-btn" (click)="refreshTable()" [disabled]="isRefreshing" matTooltip="Click to view the latest status">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
        <!-- for agGrid height: 625px;  -->
        <ag-grid-angular id="releaseDeploymentStatusGrid" #agGrid [style]="styleChipDiv" [rowData]="filteredRowData" [columnDefs]="columnDefs"
                [infiniteInitialRowCount]="infiniteInitialRowCount"
                [overlayNoRowsTemplate]="overlayNoRowsTemplate"
            class="ag-theme-material" [defaultColDef]="defaultColDef"
            [suppressMenuHide]="false" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>
</div>